export const SELECTIONS_FEATURE_TOKEN = 'selections'
